exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.font-xs[data-v-536eb46c] {\n    font-size: 0.7em;\n}\n.icon-hidden[data-v-536eb46c] {\n   color: transparent;\n}\n.table-stripe[data-v-536eb46c]  {\n    background-color:rgba(0,0,0,.05);\n}    \n", ""]);

// exports
